import PropTypes from 'prop-types';
import { twJoin, twMerge } from 'tailwind-merge';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import BreadcrumbItem from 'components/Breadcrumb/Item';
import TextWithEllipsisWithShowMore from 'components/TextWithEllipsisWithShowMore';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const NOT_EXPANDED_DESCRIPTION_LIMIT = 185;

const isDescriptionTextExpandable = (description) =>
  description && description.length > NOT_EXPANDED_DESCRIPTION_LIMIT;

const LandingHeading = ({
  breadcrumbActiveItem = null,
  className,
  description = null,
  isBreadcrumbActive,
  isDescriptionInitiallyCollapsed = null,
  size = 'size3',
  title,
}) => (
  <div
    className={twMerge('mb-4', !isBreadcrumbActive && 'mt-[110px]', className)}
  >
    {isBreadcrumbActive && (
      <Breadcrumb className="pb-0">
        <BreadcrumbItem href={LINKS.HOME}>
          {placeholder('breadcrumbs.app')}
        </BreadcrumbItem>
        <BreadcrumbItem>{breadcrumbActiveItem}</BreadcrumbItem>
      </Breadcrumb>
    )}
    <Heading as="h1" className="mt-4" size={size}>
      {title}
    </Heading>
    {description &&
      (isDescriptionInitiallyCollapsed &&
      isDescriptionTextExpandable(description) ? (
        <TextWithEllipsisWithShowMore
          className="mt-2 hidden max-w-[730px]"
          lineClampClassName={isDescriptionInitiallyCollapsed && 'line-clamp-2'}
        >
          {description}
        </TextWithEllipsisWithShowMore>
      ) : (
        <Text
          className={twJoin(
            'mt-2 hidden max-w-[730px]',
            isDescriptionInitiallyCollapsed && 'line-clamp-2'
          )}
        >
          {description}
        </Text>
      ))}
  </div>
);

LandingHeading.propTypes = {
  breadcrumbActiveItem: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  description: PropTypes.string,
  isBreadcrumbActive: PropTypes.bool.isRequired,
  isDescriptionInitiallyCollapsed: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default LandingHeading;
